const invoicePrintTemplates = [
	{
		name: 'template1',
		image: 'invoicePrintTemplates.template1.image'
	},
	{
		name: 'template2',
		image: 'invoicePrintTemplates.template2.image'
	},
	{
		name: 'template3',
		image: 'invoicePrintTemplates.template3.image'
	},
	{
		name: 'template4',
		image: 'invoicePrintTemplates.template4.image'
	},
	{
		name: 'template5',
		image: 'invoicePrintTemplates.template5.image'
	}
];

const labelPrintTemplates = [
	{
		name: 'template1',
		image: 'labelPrintTemplates.template1.image'
	},
	{
		name: 'template2',
		image: 'labelPrintTemplates.template2.image'
	},
	{
		name: 'template3',
		image: 'labelPrintTemplates.template3.image'
	},
	{
		name: 'template4',
		image: 'labelPrintTemplates.template4.image'
	},
	{
		name: 'template5',
		image: 'labelPrintTemplates.template5.image'
	}
];

const awbPrintTemplates = [
	{
		name: 'template1',
		image: 'awbPrintTemplates.template1.image'
	}
];

const settingTypes = [
	{
		label: 'invoicePrintType',
		description: 'invoicePrintTypeDescription',
		formFieldName: 'invoicePrintPropJSON',
		templates: invoicePrintTemplates
	},
	{
		label: 'labelPrintType',
		description: 'labelPrintTypeDescription',
		formFieldName: 'branchPrintPropJSON',
		roleName: 'BranchModule',
		templates: labelPrintTemplates
	},
	{
		label: 'AWBPrintType',
		description: 'AWBPrintTypeDescription',
		formFieldName: 'awbPrintPropJSON',
		templates: awbPrintTemplates
	}
];

export default settingTypes;
